import { Button } from "@/components/ui/atoms/Button/Button";

type AdminSettingsDisplayCardProps = {
  title: string;
  value: string;
  preview: string;
  selected: boolean;
  onSelect: (value: string) => void;
}

const AdminSettingsDisplayCard = ({ title, value, preview, selected, onSelect }: AdminSettingsDisplayCardProps): JSX.Element => {
  return (
    <div className="flex flex-col gap-2w justify-center items-center w-fit">
      <div className="flex flex-col gap-1w justify-center items-center border-4 rounded-lg border-admin-blue-300 p-2w w-full">
        <h1 className="text-header6 font-bold text-admin-blue-400">{title}</h1>
        <img src={preview} alt={title} className="h-[220px]" />
        <Button variant="secondary">APERCU</Button>
      </div>
      <Button variant={selected ? 'default' : 'secondary'} onClick={() => onSelect(value)}>{selected ? 'SÉLECTIONNÉ' : 'SÉLECTIONNER'}</Button>
    </div>
  )
}

export default AdminSettingsDisplayCard;